import { createAsyncThunk } from '@reduxjs/toolkit';
import getQuizResultsRequest from './api';

const fetchQuizResults = createAsyncThunk(
  'quizResults/fetch',
  async (featureId, { rejectWithValue }) => {
    try {
      const res = await getQuizResultsRequest(featureId);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to load quiz results'
      );
    }
  }
);

export default fetchQuizResults;
